"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedInLoginButton = LinkedInLoginButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const auth_1 = require("@src/types/auth");
const icons_1 = require("@ant-design/icons");
const useConfig_1 = require("@src/hooks/useConfig");
const randomstring_1 = __importDefault(require("randomstring"));
const LinkedInLoginButton_style_1 = require("./LinkedInLoginButton.style");
function LinkedInLoginButton({ type }) {
    const config = (0, useConfig_1.useConfig)();
    const determineButtonText = () => {
        if (type === auth_1.OAuthType.login) {
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "linkedin.login", defaultMessage: "Prihl\u00E1si\u0165 cez linkedin" });
        }
        if (type === auth_1.OAuthType.registration) {
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "linkedin.registration", defaultMessage: "Registrova\u0165 cez linkedin" });
        }
    };
    const linkedinButtonText = determineButtonText();
    const scopes = 'r_liteprofile r_emailaddress';
    const redirect = type === auth_1.OAuthType.login || type === auth_1.OAuthType.registration
        ? `${config.baseUrl}/prihlasenie`
        : `${config.baseUrl}/ucet/zivotopis`;
    const linkedinAuthorization = async () => {
        const generatedStateString = randomstring_1.default.generate(10);
        window.localStorage.setItem('pracuj_linkedin_state_string', generatedStateString);
        const url = `${config.linkedinAuthUri}/authorization?response_type=code&client_id=${process.env.LINKEDIN_CLIENT_ID}&scope=${scopes}&state=${generatedStateString}&redirect_uri=${redirect}`;
        window.location.href = url;
    };
    return ((0, jsx_runtime_1.jsxs)(LinkedInLoginButton_style_1.LinkedInButton, { size: "middle", type: "default", onClick: linkedinAuthorization, children: [(0, jsx_runtime_1.jsx)(icons_1.LinkedinFilled, { className: "m-r-m" }), linkedinButtonText] }));
}
